// removed by extract-text-webpack-plugin
module.exports = {"bold":"app-pages-RegisterComplete-__style___2SamA","logoButton":"app-pages-RegisterComplete-__style___26EgS","noOffset":"app-pages-RegisterComplete-__style___31YAZ"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/RegisterComplete/style.css
// module id = 509
// module chunks = 0